import React, { FC, memo } from 'react';
import Backdrop from '../Backdrop';
import Icon from '../Icon';
import ListUi from '../Icon/icons/outlined/list-ul';
import { SlidingSideMenuProps } from './types';
import { StyledSideMenu, StyledIconWrapper, IconStyle } from './styles';
import { cx } from '../customEmotion';

const SlidingSideMenu: FC<SlidingSideMenuProps> = ({
  children,
  open,
  onClick,
  onClose,
  onClosed,
  duration = 200,
  icon,
  position = 'left',
  width,
  IconProps,
  BackdropProps,
  ...restProps
}) => {
  const {
    className: IconClassName,
    ...restIconProps
  } = { ...IconProps };
  const {
    className: BackdropClassName,
    ...restBackdropProps
  } = { ...BackdropProps };

  const handleClose = () => {
    onClose();

    // after transition finished
    setTimeout(() => {
      if (onClosed) {
        onClosed();
      }
    }, duration);
  };

  const handleIconClick = () => {
    if (open) {
      handleClose();
    } else {
      onClick();
    }
  };

  return (
    <section>
      { icon
          ? <span onClick={handleIconClick}>{icon}</span>
          : (
            <StyledIconWrapper onClick={handleIconClick}>
              <Icon
                icon={ListUi}
                className={cx(IconStyle, IconClassName)}
                {...restIconProps}
              />
            </StyledIconWrapper>
          )
      }
      <StyledSideMenu
        open={open}
        duration={duration}
        position={position}
        width={width}
        {...restProps}
      >
        {children}
      </StyledSideMenu>
      <Backdrop
        open={open}
        onClick={handleClose}
        className={BackdropClassName}
        {...restBackdropProps}
      />
    </section>
  );
};

export default memo(SlidingSideMenu);
